module.exports = __webpack_public_path__ + "media/images/carta-final-492df825c9c806b000c30050c4a083f8.png";